import BundlesApi from 'Api/bundles';

export const BUNDLES_REQUEST = 'BUNDLES_REQUEST';
export const BUNDLES_SUCCESS = 'BUNDLES_SUCCESS';
export const BUNDLES_ERROR = 'BUNDLES_ERROR';
export const BUNDLES_UPDATE_SUCCESS = 'BUNDLES_UPDATE_SUCCESS';
export const BUNDLES_UPDATE_REQUEST = 'BUNDLES_UPDATE_REQUEST';

export function loadBundles (criteria) {
    return function (dispatch) {
        return dispatch({
            request: BundlesApi.loadItem(criteria),
            requestType: 'BUNDLES',
        });
    };
}

export function updateBundles (values, formValues, inviteHash) {
    return function (dispatch) {
        return dispatch({
            request: BundlesApi.updateItem(values, formValues, inviteHash),
            requestType: 'BUNDLES_UPDATE',
        });
    };
}
